import React from 'react';
import { reactionSentence } from '../utils/textReactions';

/**
 * A tapback where there's no room for the bubble (issue cards, toasts): what
 * they reacted with, then our text cut to one line, instead of the phone's raw
 * 'Questioned “Twigs: …the whole message…”'.
 */
const TextReactionLine = ({ reaction, className = '' }) => (
  <span className={`flex min-w-0 flex-col ${className}`}>
    <span>{reactionSentence(reaction)}</span>
    {reaction.quoted && <span className="truncate text-gray-600">“{reaction.quoted}”</span>}
  </span>
);

export default TextReactionLine;
